import React from 'react';

import Loader from 'components/shared/Loader';

import useFormLayout from './functions';
import Header from './Header';
import styles from './index.module.css';

const Layout = ({ children, type }) => {
  const { loading } = useFormLayout({ type });

  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <Header type={type} />

        <div className={styles.sections} id="formSections">
          {!loading ? children : <Loader isFillBlock />}
        </div>
      </div>

      <div id="modal-root" />
    </div>
  );
};

export default Layout;
